export default {
  init(vue) {
    return {
      query(params) {
        return vue.$http({
          method: 'GET',
          url: '/pages/app/list',
          params: params
        })
      },
      save(data) {
        return vue.$http({
          method: 'POST',
          url: '/pages/app/save',
          data: data
        })
      },
      getById(id) {
        return vue.$http({
          method: 'GET',
          url: '/pages/app/get',
          params: {
            id: id
          }
        })
      },
      deleteById(id) {
        return vue.$http({
          method: 'GET',
          url: '/pages/app/delete',
          params: {
            id: id
          }
        })
      },
      queryUsers(params) {
        return vue.$http({
          method: 'GET',
          url: '/pages/app/user/list',
          params: params
        })
      },
      saveUser(data) {
        return vue.$http({
          method: 'POST',
          url: '/pages/app/user/save',
          data: data
        })
      },
      queryAlarmList(params) {
        return vue.$http({
          method: 'GET',
          url: '/alarm/pages/rule/subscribe/list',
          params: params
        })
      },
      saveAlarm(data) {
        return vue.$http({
          method: 'POST',
          url: '/alarm/pages/rule/subscribe/save',
          data: data
        })
      },
      deleteAlarmById(obj) {
        return vue.$http({
          method: 'POST',
          url: '/alarm/pages/rule/subscribe/delete',
          params: {
            ...obj
          }
        })
      },
      resumeAlarmById(obj) {
        return vue.$http({
          method: 'POST',
          url: '/alarm/pages/rule/subscribe/resume',
          params: {
            ...obj
          }
        })
      },
      getUserById(id) {
        return vue.$http({
          method: 'GET',
          url: '/pages/app/user/get',
          params: {
            id: id
          }
        })
      },
      deleteUserById(id) {
        return vue.$http({
          method: 'POST',
          url: '/pages/app/user/delete',
          params: {
            id: id
          }
        })
      },
      queryOrders(params) {
        return vue.$http({
          method: 'GET',
          url: '/pages/app/order/list',
          params: params
        })
      },
      /**
       * billType=&appCode=&page=&limit=
       * @param {
       *  billType: 'day'  // [day, month]
       *  appCode: 1,
       *  page: 1,
       *  limit: 10
       * } params 
       * @returns 
       */
      getAppBill(params) {
        return vue.$http({
          method: 'GET',
          url: '/pages/app/bill/getAppBill',
          params: params
        })
      },
      addAppCredit(data) {
        const formdata = new FormData();
        Object.keys(data).forEach(key => {
          formdata.append(key, data[key]);
        })
        return vue.$http({
          method: 'POST',
          url: '/pages/app/bill/secured/addAppCredit',
          data: formdata,
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/app.service.js